import React from 'react';
import { EBENEN } from '../../config/ebenen';
import EinstellungenFenster from '../../components/EinstellungenFenster';
import { FirmenRouten } from './firmenRouten';
import './firmenSeite.css';

// „Einstellungen der Firma“ (Profil-Nachbau F-11, F-19, F-26 mit Nachtrag; BAU-FIRMA.md 1.1 bis 1.5, PF-703): eine Seite des
// Fensters „Einstellungen“ (components/EinstellungenFenster.tsx), Abschnitt „Firma“ mit den Gruppen aus firmenLeiste.ts; der
// Firmenname steht unter der Suche. Rechts die Firmenbereiche wie bisher (firmenRouten.tsx). Keine Lesegrenze der Seite: in einer
// Sicht sperrt jeder Firmenbereich selbst (BAU-FIRMA 1.1 Punkt 4).
export default function FirmenSeite({ unten = false }: { unten?: boolean }) {
  return <EinstellungenFenster unten={unten} inhaltName={EBENEN.adminEinstellungen}>
    <FirmenRouten />
  </EinstellungenFenster>;
}
